import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Get list of exported connected user files
export const exportConnectedUsersList = () => {
  return axios.get(`${BASE_URL}/api/billing/export-connected-users-list`);
};

// Get download URL for a connected user export file
export const getConnectedUsersDownloadUrl = (resellerId, filename) => {
  const url = `${BASE_URL}/api/billing/download-connected-users`;
  return axios.post(url, {
    filename,
  });
};

